// extracted by mini-css-extract-plugin
export default {"page":"Page_page__keULy","page__content":"Page_page__content__ekC87","content":"Page_content__fYfAE"};